import { fetcherAuth } from "@/libs/utils";
import { useAuthStore } from "@/stores/authStore";
import useSWR from "swr";
import { shallow } from "zustand/shallow";

type Promotionlist = {
  id: string;
  name: string;
  img: string;
  description: string;
};

type UsePromotionListReturn = {
  data: Promotionlist[] | null;
  isLoading: boolean;
  isError: any;
};

export default function usePromotionList(): UsePromotionListReturn {
  const [isLoggedIn] = useAuthStore((state) => [state.user], shallow);
  const { data, error } = useSWR<UsePromotionListReturn>(
    isLoggedIn ? `/api/v1/promotion/all` : null,
    fetcherAuth
  );

  return {
    data: data?.data || null,
    isLoading: !error && !data,
    isError: error,
  };
}
